var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapGetters } from "vuex";
import { Loading } from 'element-ui';
import { UrlHelper } from '../../../../helper/UrlWrapper';
var ImportDialog = (function (_super) {
    __extends(ImportDialog, _super);
    function ImportDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.befordImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.responseSuccess = false;
        _this.responseFail = false;
        _this.importSuccessNum = 0;
        _this.importFailNum = 0;
        _this.failDownLoadUrl = "";
        _this.errorMsg = "";
        _this.countdown = 0;
        _this.countdownTimer = null;
        return _this;
    }
    ImportDialog.prototype.mounted = function () {
        this.setUploadType("beford");
    };
    ImportDialog.prototype.beforeDestroy = function () {
        this.clearCountdown();
    };
    ImportDialog.prototype.befordUpload = function (file) {
        var name = file.name.split("."), fileType = name[name.length - 1];
        if (!(fileType && (fileType == "xlsx" || fileType == "xls"))) {
            this.$message.error("文件只能是xlsx或xls");
            return false;
        }
        ;
        if (!this.loadingInstance)
            this.loadingInstance = Loading.service({ fullscreen: true });
    };
    ImportDialog.prototype.uploadSuccess = function (response, file, fileList) {
        if (response.success) {
            var data = response.data;
            this.importSuccessNum = data.success_num || 0;
            this.importFailNum = data.error_num || 0;
            if (data.import_id && data.type && this.importFailNum > 0) {
                var url = "/basicapi/export_error?import_id=" + data.import_id + "&type=" + data.type;
                this.user = this.user;
                url = UrlHelper.addParam(url, 'token', this.user.token);
                this.failDownLoadUrl = url;
            }
            if (this.loadingInstance) {
                this.loadingInstance.close();
                this.loadingInstance = null;
            }
            this.setUploadType("afterImport");
            this.responseSuccess = true;
            if (this.importFailNum == 0) {
                this.$message.success("导入成功");
                this.startCountdown(10);
            }
        }
        else {
            this.uploadError(response);
        }
    };
    ImportDialog.prototype.uploadError = function (err, file, fileList) {
        this.errorMsg = err.msg || err.message || "网络异常，请重新导入";
        if (this.loadingInstance) {
            this.loadingInstance.close();
            this.loadingInstance = null;
        }
        this.setUploadType("afterImport");
        this.responseFail = true;
        if (err.msg) {
            this.$message.error(err.msg);
        }
    };
    ImportDialog.prototype.uploadProgress = function (event, file, fileList) {
        this.setUploadType("importting");
    };
    ImportDialog.prototype.setUploadType = function (type) {
        this.befordImport = false;
        this.importting = false;
        this.afterImport = false;
        this.responseSuccess = false;
        this.responseFail = false;
        switch (type) {
            case "beford":
                this.befordImport = true;
                break;
            case "importting":
                this.importting = true;
                break;
            case "afterImport":
                this.afterImport = true;
                break;
        }
    };
    ImportDialog.prototype.isImportSuccess = function () {
        return this.responseSuccess;
    };
    ImportDialog.prototype.startCountdown = function (seconds) {
        var _this = this;
        this.countdown = seconds;
        this.countdownTimer = setInterval(function () {
            _this.countdown--;
            if (_this.countdown <= 0) {
                _this.clearCountdown();
                _this.$emit("importDialog:ok");
            }
        }, 1000);
    };
    ImportDialog.prototype.clearCountdown = function () {
        if (this.countdownTimer) {
            clearInterval(this.countdownTimer);
            this.countdownTimer = null;
        }
        this.countdown = 0;
    };
    ImportDialog = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                "user": "user"
            }))
        })
    ], ImportDialog);
    return ImportDialog;
}(Vue));
export default ImportDialog;
